import {
  GET_DEVICES,
  GET_DEVICES_SUCCESS,
  GET_DEVICES_FAIL,
  ADD_DEVICES,
  ADD_DEVICES_SUCCESS,
  ADD_DEVICES_FAIL,
  UPDATE_DEVICES,
  UPDATE_DEVICES_SUCCESS,
  UPDATE_DEVICES_FAIL,
  RESET_DEVICE_MESSAGE,
  UNPAIR_DEVICES,
  UNPAIR_DEVICES_SUCCESS,
  UNPAIR_DEVICES_FAIL,
} from "./actionTypes";
export const resetMessages = () => {
  return {
    type: RESET_DEVICE_MESSAGE,
  };
};
export const getDevices = (payload) => {
  return {
    type: GET_DEVICES,
    payload,
  };
};

export const getDevicesSuccess = (devices) => {
  return {
    type: GET_DEVICES_SUCCESS,
    payload: devices,
  };
};

export const getDevicesFail = (error) => {
  return {
    type: GET_DEVICES_FAIL,
    payload: error,
  };
};

export const addDevices = (payload) => {
  return {
    type: ADD_DEVICES,
    payload,
  };
};

export const addDevicesSuccess = (devices) => {
  return {
    type: ADD_DEVICES_SUCCESS,
    payload: devices,
  };
};

export const addDevicesFail = (error) => {
  return {
    type: ADD_DEVICES_FAIL,
    payload: error,
  };
};
export const updateDevices = (payload) => {
  return {
    type: UPDATE_DEVICES,
    payload,
  };
};

export const updateDevicesSuccess = (devices) => {
  return {
    type: UPDATE_DEVICES_SUCCESS,
    payload: devices,
  };
};

export const updateDevicesFail = (error) => {
  return {
    type: UPDATE_DEVICES_FAIL,
    payload: error,
  };
};
export const unpairDevices = (payload) => {
  return {
    type: UNPAIR_DEVICES,
    payload,
  };
};

export const unpairDevicesSuccess = (payload) => {
  return {
    type: UNPAIR_DEVICES_SUCCESS,
    payload: payload,
  };
};

export const unpairDevicesFail = (error) => {
  return {
    type: UNPAIR_DEVICES_FAIL,
    payload: error,
  };
};
